export class PlanStatusInputModel {
  constructor(
    public type: string,
    public icon: string,
    public title: string,
    public description: string,
    public hasMore: boolean,
    public isFasting: boolean,
    public hasDelete?: boolean,
    public needReturn?: boolean,
    public duration?: number,
    public endTime?: number
  ) {}
}
